import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import React from "react";

const DialogTitle = withStyles((theme) => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 3,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
  },
}))((props) => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
class AlertDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.onClose}
        fullScreen={this.props.fullScreen}
        maxWidth={this.props.maxWidth}
        fullWidth={this.props.fullWidth}
        disableBackdropClick={true}
        scroll={"paper"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ width: "100%" }}>
        {this.props.input ? (
          <DialogTitle
            id="customized-dialog-title"
            onClose={this.props.onClose}>
            {this.props.title}
          </DialogTitle>
        ) : (
          <MuiDialogTitle id="alert-dialog-title">
            {this.props.title}
          </MuiDialogTitle>
        )}
        <DialogContent>
          {this.props.message ? (
            <DialogContentText id="alert-dialog-description">
              {this.props.message}
            </DialogContentText>
          ) : (
            this.props.input
          )}
        </DialogContent>
        {this.props.button ? (
          <DialogActions>
            <Button onClick={this.props.onClose} color="secondary">
              Hủy
            </Button>
            <Button
              onClick={this.props.onSubmit}
              color="primary"
              variant="contained"
              autoFocus>
              Thực hiện
            </Button>
          </DialogActions>
        ) : this.props.buttonExit ? (
          <DialogActions>
            <Button
              onClick={this.props.onClose}
              color="primary"
              variant="contained">
              Thoát
            </Button>
          </DialogActions>
        ) : (
          this.props.otherButton
        )}
      </Dialog>
    );
  }
}
AlertDialog.propTypes = {
  title: PropTypes.any,
  message: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  otherButton: PropTypes.node,
  input: PropTypes.object,
  button: PropTypes.bool,
  fullScreen: PropTypes.bool,
  fullWidth: PropTypes.bool,
  maxWidth: PropTypes.string,
  buttonExit: PropTypes.bool,
};

AlertDialog.defaultProps = {
  button: false,
  fullScreen: false,
  fullWidth: false,
  open: false,
};

export default AlertDialog;
